define(function (require) {
    "use strict";

    var SecureUtilities = (function () {
        var entityMap = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': '&quot;',
            "'": '&#x27;',
            "/": '&#x2F;'
        };

        return {
            //Escaping Approach
            /**
             * Escape html   ( taken from mustache as it is 1 to 1 whats is needed according to rule 1 at
             * https://www.owasp.org/index.php/XSS_(Cross_Site_Scripting)_Prevention_Cheat_Sheet#RULE_.232_-_Attribute_Escape_Before_Inserting_Untrusted_Data_into_HTML_Common_Attributes
             * Escape the following characters with HTML entity encoding to prevent switching into any execution context, such as script, style, or event handlers. Using hex entities is recommended in the spec.
             * In addition to the 5 characters significant in XML (&, <, >, ", '), the forward slash is included as it helps to end an HTML entity.
             */
            escapeForHtmlContent: function (value) {
                return String(value).replace(/[&<>"'\/]/g, function (s) {
                    return entityMap[s];
                });
            },

            unescapeBRForHtml: function (text) {
                // Unescape two possible ways to represent a br element
                var encodedBr1 = this.escapeForHtmlContent("<br />");
                var encodedBr2 = this.escapeForHtmlContent("<br/>");
                var re = new RegExp("(" + encodedBr1 + "|" + encodedBr2 + ")", "gi"); // ignore case
                return text.replace(re, "<br/>");
            },

            /**
             * is for putting untrusted data into typical attribute values like width, name, value, etc.
             * This should not be used for complex attributes like href, src, style, or any of the event handlers like onmouseover.
             * It is extremely important that event handler attributes should follow Rule #3 for HTML JavaScript Data Values.
             * @param value
             * @returns {string}
             */
            escapeForHtmlAttributes: function (value) {
                var retval = '';
                if (typeof(value) != 'undefined' && value != null) {
                    for (var i = 0; i < value.length; i++) {
                        retval += '&#x' + value.charCodeAt(i).toString(16) + ';';
                    }
                }
                return retval;
            }
        };
    })();

    return SecureUtilities;
});
